module.exports = __webpack_public_path__ + "static/media/road_work.eb463dbf.svg";